<div
	class="grid grid-cols-1 h-full w-full py-8 pl-5"
	style="grid-template-rows: 1fr min-content"
>
	<div
		class="flex flex-col text-grey-darker overflow-auto h-full pr-5"
		*ngIf="matter$ | async as matter"
	>
		<div class="flex border-grey-light pb-4 items-end gap-1.5 border-b">
			<app-matter-status-indicator
				class="block flex-none text-xs"
				[status]="matter.status"
			></app-matter-status-indicator>
			<div class="text-3xl font-bold invisible flex-auto">
				&nbsp;<!-- hack for height and spacing -->
			</div>
			<div class="text-sm">#{{ matter.number }}</div>
			<app-matter-type-icon [fileType]="matter.fileType"></app-matter-type-icon>
		</div>

		<div class="text-xl pt-5">{{ matter.name }}</div>

		<div
			class="flex flex-wrap gap-1 pt-3 text-sm text-grey font-bold"
			*ngIf="labels$ | async as labels"
		>
			<span *ngFor="let label of labels; last as isLast"
				>{{ label | capitalize
				}}<span class="font-normal" *ngIf="!isLast">&nbsp;|</span></span
			>
		</div>

		<div
			class="grid grid-cols-2 gap-y-3 text-sm pt-4 pb-6 border-grey-light border-b"
		>
			<div>Closing</div>
			<div class="text-right font-bold">
				<ng-container *ngIf="matter?.closingDate as cDate; else noDates">{{
					cDate | sqlDate | date: 'mediumDate'
				}}</ng-container>
			</div>

			<div>Appointment</div>
			<div class="text-right font-bold">
				<ng-container
					*ngIf="matter.appointment?.appointmentTime as aDate; else noDates"
					>{{ aDate | date: 'mediumDate' }}</ng-container
				>
			</div>

			<div>Requisition</div>
			<div class="text-right font-bold">
				<ng-container
					*ngIf="matter.titleSearchCompletionDate as rDate; else noDates"
					>{{ rDate | sqlDate | date: 'mediumDate' }}</ng-container
				>
			</div>

			<div>Occupancy</div>
			<div class="text-right font-bold">
				<ng-container *ngIf="matter.occupancyDate as oDate; else noDates">{{
					oDate | sqlDate | date: 'mediumDate'
				}}</ng-container>
			</div>
		</div>

		<div
			class="grid grid-cols-2 py-6 border-grey-light gap-y-3 text-sm border-b"
		>
			<div>Street</div>
			<div class="text-right justify-end font-bold">
				<ng-container
					*ngIf="
						matter.propertyDetails?.address | address: 'short' as address;
						else noProperty
					"
					>{{ address }}</ng-container
				>
			</div>
			<div>City, Prov.</div>
			<div class="text-right justify-end font-bold">
				<ng-container
					*ngIf="
						matter.propertyDetails?.address
							| address: 'cityProvinceCode' as address;
						else noProperty
					"
					>{{ address }}</ng-container
				>
			</div>
		</div>

		<div class="flex flex-wrap gap-x-12">
			<div class="inline-grid grid-cols-1">
				<div class="pb-4 pt-6 text-sm">Clients</div>
				<ng-container *ngIf="(clients$ | async)?.length; else noParties">
					<div class="flex gap-3">
						<app-contact-name-badge
							*ngFor="let client of clients$ | async"
							[contact]="client"
						></app-contact-name-badge>
					</div>
				</ng-container>
			</div>

			<div class="inline-grid grid-cols-1">
				<div class="pb-4 pt-6 text-sm">Other party</div>
				<ng-container
					*ngIf="
						(otherPartiesLawyer$ | async) || (otherPartiesClerk$ | async);
						else noOtherParties
					"
				>
					<div class="flex gap-3">
						<app-contact-name-badge
							*ngIf="otherPartiesLawyer$ | async as lawyer"
							[contact]="lawyer"
							[lawFirm]="otherPartiesFirm$ | async"
							heading="Other party (lawyer)"
						></app-contact-name-badge>
						<app-contact-name-badge
							*ngIf="otherPartiesClerk$ | async as clerk"
							[contact]="clerk"
							[lawFirm]="otherPartiesFirm$ | async"
							heading="Other party (clerk)"
						></app-contact-name-badge>
					</div>
				</ng-container>
			</div>
		</div>
	</div>

	<div class="flex justify-end pt-3 pr-5">
		<a
			(click)="goToMatter($event)"
			href="#"
			class="text-sm font-bold"
			style="color: var(--closer-blue-highlight)"
			mat-dialog-close
			data-intercom-target="calendar-modal-go-to-file"
			>Go to file<app-icon class="ml-1" [icon]="ICON.ARROW_RIGHT"></app-icon
		></a>
	</div>
</div>

<ng-template #na let-link="link">
	<a *ngIf="!!link" [routerLink]="link" class="na-icon"
		><app-icon [icon]="ICON.WARNING" mat-dialog-close></app-icon
	></a>
	<span *ngIf="!link" class="text-grey-light font-bold text-sm">NA</span>
</ng-template>

<ng-template #noDates>
	<ng-container
		*ngTemplateOutlet="na; context: { link: matterOverviewUrl$ | async }"
	></ng-container>
</ng-template>

<ng-template #noProperty>
	<ng-container
		*ngTemplateOutlet="na; context: { link: matterPropertyUrl$ | async }"
	></ng-container>
</ng-template>

<ng-template #noParties>
	<ng-container
		*ngTemplateOutlet="na; context: { link: matterPartiesUrl$ | async }"
	></ng-container>
</ng-template>

<ng-template #noOtherParties>
	<ng-container
		*ngTemplateOutlet="na; context: { link: matterOtherPartiesUrl$ | async }"
	></ng-container>
</ng-template>
